import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import MainLayout from '../../components/layout/MainLayout';
import { createDealer, listDealers } from '../../api/backendApi';
import { ROUTES } from '../../utils/constants';
import { rowsFrom, safeDealerError } from './dealerAccess';

const WARNINGS = [
  'Dealer access is limited to assigned tenants.',
  'Tenant assignment does not change tenant ownership or Sites.',
  'Dealer billing and markup are not configured in this phase.',
  'Disabling a Dealer immediately blocks Dealer access.',
];

export default function DealerManagementPage() {
  const [dealers, setDealers] = useState([]);
  const [name, setName] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    return listDealers()
      .then((response) => setDealers(rowsFrom(response)))
      .catch((err) => setError(safeDealerError(err)))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const onCreate = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await createDealer({
        name,
        ...(contactName ? { contactName } : {}),
        ...(contactEmail ? { contactEmail } : {}),
      });
      setName('');
      setContactName('');
      setContactEmail('');
      await load();
    } catch (err) {
      setError(safeDealerError(err));
    }
  };

  return (
    <MainLayout scrollMain>
      <Box sx={{ p: 3, maxWidth: 880 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>Dealers</Typography>
        <Typography sx={{ mb: 2 }} color="text.secondary">
          Superadmin management for Dealer records, assigned tenants, and Dealer Admins.
        </Typography>
        {WARNINGS.map((warning) => (
          <Alert key={warning} severity="info" sx={{ mb: 1 }}>{warning}</Alert>
        ))}
        {error ? <Alert severity="error" sx={{ my: 2 }}>{error}</Alert> : null}
        <Box component="form" onSubmit={onCreate} sx={{ display: 'grid', gap: 2, my: 3, maxWidth: 480 }}>
          <TextField label="Dealer name" value={name} onChange={(event) => setName(event.target.value)} required />
          <TextField label="Contact name" value={contactName} onChange={(event) => setContactName(event.target.value)} />
          <TextField label="Contact email" value={contactEmail} onChange={(event) => setContactEmail(event.target.value)} />
          <Button type="submit" variant="contained" disabled={!name.trim()}>Add Dealer</Button>
        </Box>
        {loading ? <Typography>Loading dealers…</Typography> : null}
        {!loading && dealers.length === 0 ? <Typography>No dealers yet.</Typography> : null}
        <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
          {dealers.map((dealer) => (
            <li key={dealer.dealerId}>
              <Button
                component={Link}
                to={ROUTES.ADMIN_DEALER_DETAIL.replace(':dealerId', dealer.dealerId)}
                sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
              >
                {dealer.name} · {dealer.status}
              </Button>
            </li>
          ))}
        </Box>
      </Box>
    </MainLayout>
  );
}
